import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=62fba5ee&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"
import style0 from "./Foot.vue?vue&type=style&index=0&id=62fba5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fba5ee",
  null
  
)

export default component.exports